import { Button, Grid } from '@material-ui/core';
import { ShortBody } from 'components/Typography';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  color: #172c51 !important;
  background-color: #f4b63e !important;
  border: #1974fe !important;
`;

export const StyledShortBody = styled(ShortBody)`
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5); ;
`;

export const StyledGrid = styled(Grid)<{ backgroundImage: string }>`
  width: 271px !important;
  height: 263px !important;
  background-blend-mode: overlay;
  background-image: ${({ backgroundImage }) =>
    `url(${backgroundImage}), linear-gradient(180deg, rgba(0,0,0,0.5) -20%, rgba(0,0,0,0) 100%)`};
  background-position: center;
  background-repeat: no-repeat;
  padding: 16px 24px;
  border-radius: 8px;
`;

export const StyledLink = styled.a`
  text-decoration: none;
`;

export const StyledCarouselContainer = styled.div`
  && {
    .carousel.carousel-slider .control-arrow:hover {
      background: none;
    }
    .carousel-status {
      display: none;
    }
    .carousel .control-dots {
      position: relative;
      margin: 10px 0;
      padding: 0;
      text-align: center;
      bottom: 7px;
      right: auto;
      width: 100%;
      height: 8px;
    }
    .MuiGrid-container {
      margin: 0 auto;
    }
    .direction {
      direction: initial;
    }
    .control-dots .selected {
      background-color: #0075c9;
    }

    .carousel .control-dots li:hover {
      opacity: 0.3;
    }

    .carousel .slide {
      text-align: start;
      border-radius: 8px;
      background-color: transparent;
    }

    .carousel .control-prev.control-arrow:before {
      border-right: 8px solid #dadada;
    }

    .carousel .control-next.control-arrow:before {
      border-left: 8px solid #dadada;
    }
  }
`;
